import generateCharacterSprite from "./generateCharacterSprite"

export const defaultColors = {
  shirt: "#4763C6",
  hair: "#AF2D11",
  skin: "#FEE7D5",
  pants: "#030D33",
  shoes: "#344170",
  mouth: "#F1CFCF",
  eyes: "#030D33",
}

export const CharacterFace = ({
  hair = defaultColors["hair"],
  skin = defaultColors["skin"],
  mouth = defaultColors["mouth"],
  eyes = defaultColors["eyes"],
}) => (
  <svg width="100" height="81" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill={skin} d="M12 19h75v50H12zM19 69h62v6H19zM31 75h38v6H31z" />
    <path fill={mouth} d="M37 56h25v13H37z" />
    <path fill={eyes} d="M28 37h6v10h-6zM65 37h7v10h-7z" />
    <path
      fill={hair}
      d="M12 0h75v6H12zM6 6h87v6H6zM0 12h100v7H0zM87 19h13v12H87zM0 19h12v12H0zM87 31h6v13h-6zM6 31h6v13H6z"
    />
  </svg>
)

export const Character = (props) => {
  return (
    <div className="d-flex flex-column align-items-center">
      <div className="position-relative" style={{ minHeight: 0 }}>
        <input
          type="image"
          className="character"
          alt=""
          style={{
            backgroundImage: props.done
              ? "none"
              : `url('data:image/svg+xml;utf8, ${generateCharacterSprite(
                  props.colors
                )}')`,
            filter: props.selected ? "drop-shadow(0px 0px 6px #565695)" : "",
          }}
          onClick={props.onSelect}
        />
        <span
          className="position-absolute m-0 text-white"
          style={{
            fontFamily: "Courier New, Courier",
            fontWeight: "bold",
            fontSize: "1.5rem",
            top: 69,
            right: 65,
            pointerEvents: "none",
          }}
        >
          {props.letter}
        </span>
      </div>
      {!props.done && <span className="text-center">{props.name}</span>}
    </div>
  )
}
